
















import { Component, Vue, Prop } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { AIAppType } from '@/apps/open/types/ai'

@Component({
  componentName: 'EditAppDialogBody'
})
export default class EditAppDialogBody extends Vue {
  @Prop()
  data?: any

  @Prop()
  submit!: Function

  $refs!: {
    form: ElForm
  }

  form: AIAppType = {
    app_id: '',
    app_name: '',
    app_platform: '网页平台',
    description: ''
  }

  rules = {
    app_name: [
      { required: true, message: '请填写应用名', trigger: ['blur', 'change'] }
    ],
    description: [
      { required: true, message: '请填写应用简介', trigger: ['blur', 'change'] }
    ]
  }

  onOk () {
    this.$refs.form.validate((valid: boolean) => {
      if (valid) this.submit(this.form)
    })
  }

  mounted () {
    this.$on('onOk', this.onOk)
    this.initFormData()
  }

  initFormData () {
    if (this.data) {
      this.form = {
        app_id: this.data.api_key,
        app_name: this.data.api_name,
        app_platform: '网页平台',
        description: this.data.api_intro
      }
    }
  }
}
